import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { brandRelatedAvgViewsPlaceholder } from '../../constants/placeholder';
import CustomFollowerRange from '../../components/CustomFollowerRange';
import { useSetRangeDefaultValue } from '../../hooks/init';
import { useIntl } from 'umi';
import BubbleCommon, {
  brandRelatedAvgViewsFilterTips,
} from '@op/components/BubbleCommon';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
export default function BrandRelatedAvgViewsSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  oriDefaultFilter,
  backOriDefaultValue,
}: SingleCommonType) {
  const { rangeValue, setRangeValue, followerRef, options, diffClassName } =
    useSetRangeDefaultValue({
      defaultValue,
      filterValue,
      defaultKey: 'avg_brand_views',
      subDefaultKey: 'brand_view',
      oriDefaultFilter,
      backOriDefaultValue,
      options: [
        { text: 'All', value: '-' },
        { text: '0 ~ 50K', value: '0-50' },
        { text: '50K ~ 100K', value: '50-100' },
        { text: '100K ~ 500K', value: '100-500' },
        { text: '500K ~ 1M', value: '500-1000' },
        { text: '1M+', value: '1000-' },
      ],
    });

  const { formatMessage } = useIntl();
  useEffect(() => {
    const showHeader = followerRef.current?.buttonElement?.(rangeValue);
    const data = [];
    if (rangeValue !== '-') {
      const [start, end] = rangeValue.split('-');
      let dataItem: { start_brand_view: number; end_brand_view?: number } = {
        start_brand_view: Number(start) * 1000,
      };
      if (end !== '') {
        dataItem['end_brand_view'] = Number(end) * 1000;
      }
      data.push(dataItem);
    }

    onChange?.(
      'brandRelatedAvgViews',
      commonBackInfo(
        { avg_brand_views: data },
        { brandRelatedAvgViews: showHeader },
      ),
    );
  }, [rangeValue, formatMessage]);

  return (
    <BubbleCommon
      placement="top"
      showIcon={false}
      tipsMap={brandRelatedAvgViewsFilterTips}
    >
      <div className={`dbo-brand-related-avg-views-wrapper ${diffClassName}`}>
        <CustomFollowerRange
          lang={lang}
          ref={followerRef}
          options={options}
          setRangeValue={setRangeValue}
          rangeValue={rangeValue}
          placeholder={brandRelatedAvgViewsPlaceholder}
          pointKey={FilterButtonPoint.brandRelatedAvgViews}
        ></CustomFollowerRange>
      </div>
    </BubbleCommon>
  );
}
